'use client';

import Checkbox from '@mui/material/Checkbox';
import { HTMLAttributes, useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
`;

interface BasicCheckboxProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  value?: boolean;
  name?: string;
  color?: string;
  sendValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (name: string, checked: boolean) => void;
  children?: React.ReactNode;
}

export const BasicCheckbox: React.FC<BasicCheckboxProps> = ({
  value,
  name,
  color,
  sendValue,
  onChange,
  children,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!sendValue) return;

    const name = e.target.name;
    const checked = e.target.checked;

    if (onChange) {
      onChange(name, checked);
    }

    setIsChecked(checked);
    sendValue(e);
  };

  useEffect(() => {
    if (!value) {
      setIsChecked(false);
    } else {
      setIsChecked(value);
    }
  }, [value]);

  return (
    <StyledCheckbox className="checkbox" {...props}>
      <Checkbox checked={value} onChange={handleChange} name={name} />
      {children}
    </StyledCheckbox>
  );
};
